'use strict';

import _ from 'lodash';

export default {
  logIn: (state, currentUser) => {
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    state.currentUser = currentUser;
  },
  logOut: state => {
    localStorage.removeItem('currentUser');
    state.currentUser = null;
  },
  setParticipationVerification: (state, participationVerification) => {
    localStorage.setItem('participationVerification', participationVerification);
    state.participationVerification = participationVerification;
  },
  clearParticipationVerification: (state) => {
    localStorage.removeItem('participationVerification');
    state.participationVerification = null;
  },
  updateDashboardPools: (state, dashboardPools) => {
    state.dashboardPools = {
      updatedAt: new Date(),
      pools: dashboardPools
    };
  },
  updateCachedPool: (state, pool) => {
    const index = state.pools.findIndex(({pool: p}) => p.id === pool.id);
    if (index >= 0) {
      state.pools[index].pool = pool;
      state.pools[index].updatedAt = new Date();
    } else {
      state.pools.push({updatedAt: new Date, pool});
    }
  },
  destroyCachedPool: (state, id) => {
    state.pools = state.pools.filter(({pool}) => pool.id !== id);
  },
  clearCachedPools: (state) => {
    state.pools = [];
  },
  configNavigation: (state, config) => {
    const navigation = {
      enabled:       true,
      leftEnabled:   false,
      leftHandler:   null,
      leftImg:       'icon-menu.svg',
      leftRoute:     null,
      rightEnabled:  false,
      rightHandler:  null,
      rightImg:      'icon-forward.svg',
      rightRoute:    null,
      centerEnabled: true
    };
    state.navigation = {
      ...navigation,
      ..._.pick(config, Object.keys(navigation))
    }
  },
  updateParticipationsAwaitingUser: (state, participations) => {
    state.participationsAwaitingUser = participations;
  },
  resetNewPool(state) {
    state.newPool = {};
  },
  updateNewPool(state, attrs) {
    state.newPool = {...state.newPool, ...attrs};
  }
};
